module.exports = __webpack_public_path__ + "resources/right_arrow_circle.a8c015d6f6bd5669.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/right_arrow_circle.png
// module id = 761
// module chunks = 0 2